import {
  Dfs2SpectralDerived,
  Dfs2SpectralItem,
  Dfs2SpectralMetadata,
  Dfs2SpectralResponse,
  IWaveSpectraParams,
} from '../../types/waveSpectra';
import { decrypt } from '../../utils/cryptoUtils';
import { axiosInstance } from '../Api';

interface SpectraAnalysisApiResponse {
  metadata: Dfs2SpectralMetadata | null;
  items_data: Dfs2SpectralItem[] | null;
  items_derived: Dfs2SpectralDerived[] | null;
}

// const RAD_TO_DEG = Math.PI / 180;

// GetSpectraAnalysis only returns the raw 2D spectrum (spectrum_2d[time][dir][freq]).
// The frequency/directional marginal spectra it used to also return are derived
// here by integrating over the (equidistant) direction/frequency axes.
//
// E(f,θ)'s denominator (per-degree vs per-radian, e.g. DHI EUM units
// "eumUm2SecPerDegree" vs "eumUm2SecPerRad") varies per dataset - it's read
// from item.unit rather than assumed.
// function computeDerivedSpectra(
//   metadata: Dfs2SpectralMetadata,
//   items: Dfs2SpectralItem[]
// ): Dfs2SpectralDerived[] {
//   const { freqs, dirs } = metadata;
//   const dFreq = freqs.length > 1 ? freqs[1] - freqs[0] : 1;
//   // metadata.dirs is always stored in degrees regardless of item.unit - that's
//   // just the axis' own storage convention, separate from what angular unit
//   // the energy density is normalized per.
//   const dThetaDeg = dirs.length > 1 ? dirs[1] - dirs[0] : 360;

//   return items.map(({ name, unit, spectrum_2d }) => {
//     const perDegree = isPerDegreeUnit(unit);
//     // Integrate using the same angular unit E is expressed per - the total
//     // over a full circle is identical either way, so this is just picking
//     // the matching step size, not a unit conversion.
//     const dTheta = perDegree ? dThetaDeg : dThetaDeg * RAD_TO_DEG;

//     const S_f = spectrum_2d.map((dirSlice) =>
//       freqs.map((_, f) => dirSlice.reduce((sum, freqRow) => sum + freqRow[f], 0) * dTheta)
//     );

//     const S_thetaRaw = spectrum_2d.map((dirSlice) =>
//       dirSlice.map((freqRow) => freqRow.reduce((sum, value) => sum + value, 0) * dFreq)
//     );
//     // S_theta inherits E's angular unit directly from this integration -
//     // normalize to m²/deg so downstream consumers never need to know which
//     // unit the backend actually sent.
//     const S_theta = perDegree
//       ? S_thetaRaw
//       : S_thetaRaw.map((row) => row.map((value) => value * RAD_TO_DEG));

//     return { name, S_f, S_theta };
//   });
// }

export default class WaveSpectra {
  async getWaveSpectra(params: IWaveSpectraParams): Promise<Dfs2SpectralResponse> {
    const { orderId, pointName, datasetId, longitude, latitude, startDate, endDate } = params;
    const location = `${longitude},${latitude}`;

    const url =
      `/ChartNew/GetSpectraAnalysis?orderId=${orderId}&pointName=${pointName}&datasetId=${datasetId}&location=${location}&startDate=` +
      encodeURIComponent(startDate) +
      `&endDate=` +
      encodeURIComponent(endDate);

    const encryptedResponse = await axiosInstance.get(url);

    const data: SpectraAnalysisApiResponse = await decrypt(
      encryptedResponse.data.objectData,
      encryptedResponse.data.iv
    );

    console.log('data', data);

    const metadata = data?.metadata;
    const items = data?.items_data ?? [];
    const derived = data?.items_derived ?? [];

    if (!metadata) {
      return {
        metadata: { times: [], freqs: [], dirs: [], periods: [] },
        items: [],
        derived: [],
      };
    }

    return {
      metadata,
      items,
      derived,
      // TODO: remove when confirmed not necessary anymore
      // derived: computeDerivedSpectra(metadata, items),
    };
  }
}
